export default __webpack_public_path__ + "static/mastercard-87a486c03b21a5867bb489ac785c78ad.svg";